exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Jobslist css*/\n\n.job-main-outer-box {\n    display: flow-root;\n    background: #fff;\n    border: 1px solid #cecece;\n    background-color: #fff;\n    margin-bottom: 8px;\n    padding: 20px;\n    float: left;\n    width: 100%;\n    position: relative;\n  }\n\n.job-main-outer-box:hover {\n    -webkit-box-shadow: 0 0 10px #888;\n    box-shadow: 0 0 10px #888;\n  }\n\n.job-main-inner-box-list ul {\n    margin: 0 10px 0 25px;\n    padding: 0;\n    list-style: disc;\n    color: #c59d01;\n  }\n\n.job-main-inner-box-list {\n    border: 1px solid #c59d01;\n  margin: 0 0 20px 0;\n  }\n\n.job-main-inner-box-list ul li p {font-size: 11px!important;line-height: 14px!important; text-align: left;}\n\n.job-main-inner-box-list ul li {\n  border-bottom: 1px solid #d6d5d5;\n  margin: 0 0 10px 0;\n  padding: 0 0 10px 0;\n  line-height: 20px;\n}\n\n.job-main-inner-box-list ul li a {\n  color: #007bff;\nfont-size:16px;\n}\n\n.job-main-inner-box-list ul li p {\n  font-size: 14px;\n  color: #696868;\n  margin: 0;\n  padding: 0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/vjobfulllist/vjobfulllist.component.css
// module id = ../../../../../src/app/home/vjobfulllist/vjobfulllist.component.css
// module chunks = common